import './drag-drop-column-dropzone.module.scss';
import React, { forwardRef } from 'react';
export const DragDropColumnDropzone = forwardRef(({ children }, ref) => {
    return (<div styleName="dropzone" ref={ref}>
        {children}
      </div>);
});
